import { useContext } from 'react';
import ImportContext from 'src/contexts/ImportContext';
import { ContextValueEntity } from 'src/entities/import';

const useImport: () => ContextValueEntity = () => useContext(ImportContext);

export default useImport;
